import { Injectable } from '@angular/core';
import { AbstractOfflineStorageAsyncTimestampService } from 'src/app/services/immo-ip-placer-offline-changes/abstract/abstract-offline-storage-async-timestamp.service';
import { ProjectToOtherTour } from './project-to-other-tour';
import { ExpiredProjectToOtherTourRemover } from './expired-project-to-other-tour-remover';
import { NgForage } from 'ngforage';
import { NgForageTimestampService } from 'src/app/services/ng-forage/ng-forage-timestamp.service';
import { GeneralHelper } from 'src/app/helpers/general-helper';

@Injectable({
  providedIn: 'root',
})
export class ProjectToOtherTourStorageService extends AbstractOfflineStorageAsyncTimestampService<
  number,
  ProjectToOtherTour,
  ExpiredProjectToOtherTourRemover
> {
  constructor(
    protected ngForage: NgForage,
    protected ngForageTimestampService: NgForageTimestampService
  ) {
    super(
      'project-to-other-tour-',
      'project-to-other-tours',
      ngForage,
      ngForageTimestampService
    );
  }

  protected override instantiateRemover(): ExpiredProjectToOtherTourRemover {
    return new ExpiredProjectToOtherTourRemover(
      this,
      this.ngForage,
      this.ngForageTimestampService
    );
  }

  public override cleanupOfflineObject(
    object: ProjectToOtherTour
  ): Promise<void> {
    //Method not implemented.
    return Promise.resolve();
  }
  protected override verifyToStoreObject(
    projectToOtherTour: ProjectToOtherTour
  ): void {
    if (projectToOtherTour == null) {
      throw new Error('projectToOtherTour must not be null');
    }
    if (projectToOtherTour.id == null) {
      throw new Error('projectToOtherTour.id must not be null');
    }
    if (projectToOtherTour.subProject == null) {
      throw new Error('projectToOtherTour.subProject must not be null');
    }
  }

  public override convertToID(o: any): number {
    const toReturn = GeneralHelper.isNumeric(o) ? o : Number(o);
    if (!GeneralHelper.isNumeric(toReturn)) {
      throw new Error(`${o} could not be converted to number`);
    }
    return toReturn;
  }

  protected override stringifyID(id: number): string {
    return id.toString();
  }
}
